import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import { pills as Pills } from '@breezeway/brzw-components';
import { TASK_ASSIGNMENT_STATUS } from '../../../../utils/task';

import './assignment_badge.scss';

const CLASS_NAME = 'assignment-badge-v2';

const AssignmentBadge = ({ additionalText, status: { code, name }, className }) => {
  if (!code || _.isEqual(code, TASK_ASSIGNMENT_STATUS.ASSIGNED)) {
    return null;
  }

  const badgeText = `${_.upperCase(name)}${additionalText}`;

  return (
    <Pills.PillToggle
      className={classnames(CLASS_NAME, className, {
        [`${CLASS_NAME}--${code}`]: code,
      })}
      disabled
      size="small"
      text={badgeText}
    />
  );
};

AssignmentBadge.propTypes = {
  additionalText: PropTypes.string,
  className: PropTypes.string,
  status: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
  }),
};

AssignmentBadge.defaultProps = {
  additionalText: '',
};

export default AssignmentBadge;
